import { render } from "./RecurringSnapshotVolume.vue?vue&type=template&id=f339edf6&scoped=true"
import script from "./RecurringSnapshotVolume.vue?vue&type=script&lang=js"
export * from "./RecurringSnapshotVolume.vue?vue&type=script&lang=js"

import "./RecurringSnapshotVolume.vue?vue&type=style&index=0&id=f339edf6&lang=less&scoped=true"

import exportComponent from "/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f339edf6"]])

export default __exports__